'use strict';

/* eslint-env browser */
module.exports = typeof self === 'object' ? self.FormData : window.FormData;



//////////////////
// WEBPACK FOOTER
// ./~/axios/~/form-data/lib/browser.js
// module id = 682
// module chunks = 1